// extracted by mini-css-extract-plugin
export var skipAnimation = "_u-0";